import React, { StrictMode } from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

import App from './App';
import { installChunkReloadHandler } from './utils/chunkReload';

installChunkReloadHandler();

const divRoot = document.getElementById('root');
const root = ReactDOM.createRoot(divRoot);

root.render(
  <StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StrictMode>,
);
